import React from 'react';
import { connect } from 'react-redux';
import styles from '../../../../styles/user/UserProfile.module.scss';

const UserprofileCmStaffDivCommWidget = props => {
  const { userList, userProfile } = props;

  let associated_cm = userProfile.under_council_member
    ? userList.find(u => u.id === userProfile.under_council_member)
    : null;

  const staffers = userList.filter(
    staff => staff.under_council_member?.id === userProfile.id
  );

  return (
    <div
      className={`card rounded-3 border-0 ${styles['user-profile-detail-right-column-wrapper']}`}>
      <div className='card-body'>
        <table id={styles['profile-table']} className='w-100'>
          <tbody>
            {userProfile.under_council_member && associated_cm && (
              <tr className='align-top'>
                <td>Associated CM:</td>
                <td>
                  <a href={`/staff/${associated_cm.id}`}>
                    {associated_cm.full_name}
                  </a>
                </td>
              </tr>
            )}
            {staffers.length > 0 &&
              (userProfile.is_council_member ||
                userProfile.role.includes('Council Member') ||
                userProfile.role.includes('Public Advocate')) && (
                <tr className='align-top'>
                  <td>Staffers:</td>
                  <td>
                    <ul className='px-0'>
                      {staffers.map((staffer, idx) => (
                        <li key={idx}>
                          <a href={`/staff/${staffer.id}`}>
                            {staffer.full_name}
                            <em>
                              (<small>{staffer.role}</small>)
                            </em>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </td>
                </tr>
              )}

            {userProfile.divisions && (
              <tr className='align-top'>
                <td>Division/Teams:</td>
                <td>
                  {' '}
                  {/* FIX THE STYLING HERE */}
                  {userProfile.divisions.length === 1 &&
                  userProfile.divisions[0]?.division_name === 'Unassigned' ? (
                    'None assigned'
                  ) : (
                    <ul className='px-0'>
                      {userProfile.divisions.map((div, idx) => (
                        <li key={idx}>{div.division_name}</li>
                      ))}
                    </ul>
                  )}
                </td>
              </tr>
            )}
            {userProfile.committees && (
              <tr className='align-top'>
                <td>Committees</td>
                <td>
                  {' '}
                  {/* FIX THE STYLING HERE */}
                  {userProfile.committees.length === 1 &&
                  userProfile.committees[0]?.committees_name ===
                    'Unassigned' ? (
                    'None assigned'
                  ) : (
                    <ul className='px-0'>
                      {userProfile.committees.map((committee, idx) => (
                        <li key={idx}>{committee.committee_name}</li>
                      ))}
                    </ul>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    userList: state.userReducer.userList,
    userProfile: state.userReducer.userProfile,
  };
};

export default connect(mapStateToProps)(UserprofileCmStaffDivCommWidget);
